import type { Editor } from '@tiptap/core';
import { useEffect, useRef } from 'react';

export const useEditorFocusScope = (editor: Editor) => {
	const scopeRef = useRef<HTMLElement | null>(null);

	useEffect(
		() => () => {
			if (scopeRef.current) {
				editor.storage.focusScope?.unregisterScope(scopeRef.current);
			}
		},
		[editor]
	);

	return (element: HTMLElement | null) => {
		const scope = editor.storage.focusScope;
		if (scopeRef.current) {
			scope?.unregisterScope(scopeRef.current);
		}
		scopeRef.current = element;
		if (element) {
			scope?.registerScope(element);
		}
	};
};
